import {FC, useState, useEffect, useMemo} from "react";
import {MapContainer, TileLayer, Marker} from "react-leaflet";

import "leaflet/dist/leaflet.css";
import * as L from "leaflet";

const KEY_MAP: string | undefined = process.env.REACT_APP_KEY_MAP;

type MapProps = Record<string | number | symbol, any> | null;

const Map: FC<MapProps> = ({data}) => {
    const [map, setMap] = useState<L.Map>();

    const position: L.LatLngExpression = useMemo(() => {
        if (data) {
            return [data.location.lat, data.location.lng];
        }
        return [49.60988134497782, 6.13126389484623];
    }, [data]);

    const leafletIcon: L.Icon<L.IconOptions> = L.icon({
        iconUrl: `${process.env.PUBLIC_URL}/images/icon-location.svg`,
        iconSize: [36, 45],
        iconAnchor: [18, 45],
    });

    useEffect(() => {
        if (map) {
            map.panTo(position);
        }
    }, [position, map]);

    return (
        <MapContainer
            center={position}
            zoom={12}
            style={{height: "100%", width: "100%", zIndex: 0}}
            attributionControl={false}
            zoomControl={false}
            whenCreated={setMap}
        >
            <TileLayer
                url={`https://api.mapbox.com/styles/v1/max-b/ckvs9hcud0tzz15o71lo7hyag/tiles/256/{z}/{x}/{y}@2x?access_token=${KEY_MAP}`}
            />
            {data && <Marker position={position} icon={leafletIcon} />}
        </MapContainer>
    );
};

export default Map;
